GP.views.ContentMediaLayout = Backbone.Marionette.LayoutView.extend({
    initialize: function(options) {
        var view_cookie    = parseInt(options.view_cookie, 10);
        this.view_type     = (_.isFinite(view_cookie) && view_cookie === 1) ? 'grid' : 'list';
        this.home_trending = (MoshPit.get_size() == 'mobile' && (typeof home_view != 'undefined' && home_view));
        this.is_explicit_locked = this.model.get('is_locked') == true;
    },
    template: function(serialized_data) {
        if (false /* serialized_data.content && serialized_data.content.is_locked */) {
            return template('content-layout-locked', serialized_data);
        } else if (serialized_data.view_type == 'grid' && !(typeof home_view != 'undefined' && home_view)) {
            return template('content-layout-grid', serialized_data);
        } else if ((serialized_data.get_size == 'mobile') && (typeof home_view != 'undefined' && home_view)) {
            return template('content-trending-item-home', serialized_data);
        } else {
            return template('content-layout', serialized_data);
        }
    },
    className: 'content-media-item',
    serializeData: function() {
        // overwritten function for passing custom data to handlebars template
        var data = {
            content: this.model.toJSON()
        };

        // Set the modal url
        modal_data = {
            content_id: this.model.get('content_id'),
            duid: this.model.get('duid')
        };

        let current_url = (window.location.pathname + window.location.search).toLowerCase();
        if (current_url.indexOf('profile') !== -1) {
            modal_data.from_profile = 1;
        }

        if (this.model.get('tags').indexOf('PRIVATE') !== -1 || this.model.get('tags').indexOf('PRIVATE_ENFORCED') !== -1) {
            modal_data.private = 1;
        }
        data.content.modal_url  = GP.Util.clean_url('/members/content/viewer/', modal_data);

        // Set the report url
        report_data = {
            reported_duid: this.model.get('duid'),
            reported_from: 'status_update',
            content_id: this.model.get('content_id')
        };
        data.content.report_url = GP.Util.clean_url('/members/user/report_user/', report_data);

        data.view_type = this.view_type;
        data.get_size = MoshPit.get_size();

        if (this.home_trending) {
            data.content.like_count = parseInt(data.content.like_count,10);
            data.content.like_count_k = GP.Util.k_formatter(data.content.like_count);
            data.content.comment_count = parseInt(data.content.comment_count,10);
            data.content.comment_count_k = GP.Util.k_formatter(data.content.comment_count);
        }

        // change videos to the thumbnail if user is unconverted trial (so it doesn't auto play)
        if (data.content.type == 'VIDEO' && (GP.sdata.my_user.unconverted_trial || GP.sdata.my_user.membership === 'PENDING_FREE')) {
            data.content.type = 'IMAGE';
            data.content.url = data.content.video_thumb_url;
        }

        if (data.content.content_type == 'story') {
            data.content.story = GP.Util.format_story(data.content.story, 400);
        }

        return data;
    },
    templateHelpers: {
        content_type_text: function() {
            return (this.content.content_type == 'text');
        },
        content_type_story: function() {
            return (this.content.content_type == 'story');
        },
        content_type_media: function() {
            return (this.content.content_type == 'media');
        },
        content_type_image: function() {
            // return (this.content.type == 'IMAGE' && this.content.placeholder_thumb !== true);
            return (this.content.type == 'IMAGE');
        },
        content_type_video: function() {
            // return (this.content.type == 'VIDEO' && this.content.placeholder_thumb !== true);
            return (this.content.type == 'VIDEO');
        },
        safemode_chk: function() {
            var safe_mode = GP.sdata.my_user.pg;

            if (safe_mode && this.content.rating == 'R') {
                return true;
            }

            return false;
        },
        show_max_content_notice: function() {
            var max_content_rating = GP.sdata.my_user.max_content_rating.toUpperCase();

            // show your own content regardless of rating
            if (this.content.duid == GP.sdata.my_user.duid) {
                return false;
            }

            if (this.content.is_locked) {
                return false;
            }

            if (this.content.tags.indexOf('PRIVATE') !== -1 && private_status === 'APPROVED') {
                return false;
            }

            if (max_content_rating == 'PG' && this.content.rating !== 'PG') {
                return true;
            }

            if (max_content_rating == 'R' && this.content.rating == 'X') {
                return true;
            }

            return false;
        },
        show_content_text: function() {
            return ((!_.isEmpty(this.content.caption) || this.content.content_type == 'text') && this.content.placeholder_thumb !== true);
        },
        my_profile: function() {
            return (this.content.duid == GP.sdata.my_user.duid);
        },
        like_comment_shown: function() {
            return (this.content.like_count > 0 || this.content.comment_count > 0);
        },
        hide_comments: function() {
            var cookie = parseInt($.cookie('cc_ae'), 10);
            // hide if you are a MAN, not looking at your own content, and don't have the cookie set to override
            return (GP.sdata.my_user.gender == 'MAN' && this.content.duid != GP.sdata.my_user.duid && cookie !== 1);
        },
        more_comments: function() {
            // Hide 'view more comments' link for bank compliant sites or if showing all comments.
            if (_bank_site || (this.content.comments.length >= this.content.comment_count)) {
                return false;
            }

            // Show view more link if more than 10 comments on own profile, 5 otherwise.
            return ((this.content.duid == GP.sdata.my_user.duid && this.content.comment_count > 10) || this.content.comment_count > 5);
        },
        is_mobile_device: function() {
            return (_is_mobile || _is_tablet);
        },
        show_mini_profile: function() {
            return (typeof home_view != 'undefined' && home_view);
        },
        show_likes: function() {
            return (this.content.like_count > 0);
        },
        show_comments: function() {
            return (this.content.comment_count > 0);
        },
        show_likes_comments: function() {
            return (this.content.like_count > 0 || this.content.comment_count > 0);
        },
        show_primary_control: function() {
            if (this.content.type !== 'IMAGE' || this.content.media_main_pic == 'Y') {
                return false;
            } else if (this.content.tags.indexOf('PRIVATE') !== -1 || this.content.tags.indexOf('PRIVATE_ENFORCED') !== -1) {
                return false;
            } else {
                return true;
            }
        },
        show_private_control: function() {
            if (this.content.media_main_pic == 'Y') {
                return false;
            } else if (this.content.tags.indexOf('PRIVATE') !== -1 || this.content.tags.indexOf('PRIVATE_ENFORCED') !== -1) {
                return false;
            } else if (this.content.tags.indexOf('VIDEO_INTRO') !== -1) {
                return false;
            } else {
                return true;
            }
        },
        show_public_control: function() {
            // PRIVATE_ENFORCED is a new content_tag.tags that is used to prevent restricted content becoming public
            // for example in the case when male solo masturbation vids get approved during media review.
            return (this.content.tags.indexOf('PRIVATE') !== -1 && this.content.tags.indexOf('PRIVATE_ENFORCED') === -1);
        },
        show_deleted_comments_notice: function() {
            return (this.content.has_deleted_comments);
        },
        get_image_url: function() {
            return this.content.url;
        },
        get_video_thumb_url: function() {
            return ((this.content.discreet_profile === 'Y' && this.content.duid != GP.sdata.my_user.duid) ? this.content.url : this.content.video_thumb_url);
        },
        get_content: function() {
            return this.model;
        },
        blur_image: function() {
            // blur the image if content rating is X
            // user is trial user
            // and variant b in a/b test
            if (typeof self_profile_view != 'undefined' && self_profile_view === true) {
                return false;
            }
            return (this.content.rating == 'X' && GP.sdata.my_user.unconverted_trial);
        },
        is_blur: function() {
            // check for a blur url for a/b test
            let is_blur_url = false;

            if (this.content.content_type == 'media' && this.content.url.match(/cacheb/i)) {
                is_blur_url = true;
            } else if (this.content.type == 'VIDEO' && this.content.video_thumb_url.match(/cacheb/i)) {
                is_blur_url = true;
            }

            return is_blur_url;
        },
        is_locked: function() {
            return this.content.is_locked;
        }
    },
    regions: {
        countRegion: '.media-count-region',
        commentRegion: '.media-comment-region'
    },
    ui: {
        btn_media_like: '.btn-media-like',
        like_count: '.like-count',
        like_header: '.media-like-header',
        btn_more_comments: '.btn-more-comments',
        btn_comment: '.btn-comment',
        alert_throttled: '.alert-throttled',
        alert_id_throttled: '.alert-id-throttled',
        alert_general_error: '.alert-general-error',
        comment_input: '.comment-textarea',
        btn_set_primary_pic: '.btn-set-primary-pic',
        btn_content_delete: '.btn-content-delete',
        btn_comment_toggle: '.btn-comment-toggle',
        media_comment_input_wrap: '.media-comment-input-wrap',
        btn_comment_options: '.btn-comment-options',
        comment_container: '.media-comment-region',
        btn_show_comments: '.btn-show-comments',
        more_comments_link_wrap: '.more-comments-link-wrap',
        btn_set_content_private: '.btn-set-content-private',
        btn_set_content_public: '.btn-set-content-public',
        dropdown_toggle: 'button.dropdown-toggle',
        dropdown_settings: '.dropdown-settings',
        dropdown_menu: '.dropdown-menu',
        btn_btn_set_filters: '.btn-set-filters',
        js_unlock_prof_content: '.js-unlock-prof-content'
    },
    events: {
        'click @ui.btn_media_like': 'media_like',
        'click @ui.btn_more_comments': 'get_more_comments',
        'click @ui.btn_comment': 'add_comment',
        'keydown @ui.comment_input' : 'input_keydown',
        'keyup @ui.comment_input' : 'check_comment_char',
        'focus @ui.comment_input' : 'comment_input_selected',
        'click @ui.btn_set_primary_pic': 'set_primary_pic',
        'click @ui.btn_content_delete': 'delete_content',
        'click @ui.btn_comment_toggle': 'toggle_comment_input',
        'click @ui.btn_comment_options': 'toggle_comment_options',
        'click @ui.btn_show_comments': 'toggle_comments',
        'click @ui.btn_set_content_private' : 'set_private',
        'click @ui.btn_set_content_public' : 'set_public',
        'shown.bs.dropdown @ui.dropdown_settings': 'drop_down_shown',
        'click @ui.btn_btn_set_filters' : 'apply_filter',
        'click @ui.js_unlock_prof_content' : 'show_unlock_modal',
    },
    onRender: function() {
        // add unique id attribute to all the views
        this.$el.attr('id', 'content-media-' + this.model.get('content_id'));

        // Don't render the counts and comments on userhome mobile.
        if (this.home_trending) {
            this.$el.addClass('trending-item');
        } else if (this.view_type == 'list' && !this.home_trending) {

            if (!this.is_explicit_locked) {
                var count_view = new GP.views.ContentCounts({model: this.model});
                this.countRegion.show(count_view);

                // Create comment list view
                var comment_view = new GP.views.CommentList({
                    collection: this.model.get('comments'),
                    childViewOptions: {
                        parent_model: this.model
                    }
                });
                this.commentRegion.show(comment_view);
            } else {
                this.$el.children('.media-wrap').addClass('list');
            }
        } else if (this.view_type == 'grid' && !(typeof home_view != 'undefined' && home_view)) {
            // for formatting grid view region items.
            this.$el.addClass('grid-item');
        }
    },
    modelEvents: {
        'change:like_count': 'update_likes',
        'change:comment_count': 'update_comments',
        'change:comment_throttled_hourly': 'throttled_notice_hourly',
        'change:comment_throttled_daily': 'throttled_notice_daily',
        'change:id_throttled': 'id_throttled_notice',
        'change:general_error': 'general_error',
        'change:comments_collapsed': 'render',
        'change:has_deleted_comments': 'render',
        'change:media_main_pic': 'render'
    },
    onShow: function() {
    },
    input_keydown: function(e) {
        var key = e.which || e.keyCode;
        if (key && key == 13) {
            e.preventDefault();
            this.add_comment(e);
            return;
        }
    },
    comment_input_selected: function() {
        this.ui.media_comment_input_wrap.addClass('input-selected');
    },
    media_like: function(e) {
        e.preventDefault();

        if (GP.sdata.my_user.membership == 'FREE') {
            GP.vent.trigger('Page:billing_redirect');
        } else {
            if (this.ui.btn_media_like.hasClass('liked')) {
                this.decrement_likes();
            } else {
                this.increment_likes();
            }
        }
    },
    decrement_likes: function() {
        GP.vent.trigger('Content:decrement_likes',  this.model);
    },
    increment_likes: function() {
        GP.vent.trigger('Content:increment_likes',  this.model);
    },
    update_likes: function() {
        this.ui.btn_media_like.toggleClass('liked');
    },
    get_more_comments: function(e) {
        e.preventDefault();

        // if (this.ui.comment_container.hasClass('hide')) {
        //     this.ui.comment_container.removeClass('hide');
        //     return;
        // }

        GP.vent.trigger('Content:get_more_comments',  this.model);
    },
    add_comment: function(e) {
        e.preventDefault();

        var comment_data = {};
        comment_data.model = this.model;
        comment_data.body = this.ui.comment_input.val();

        if (GP.sdata.my_user.membership == 'FREE') {
            GP.vent.trigger('Page:billing_redirect');
        } else {
            this.ui.comment_container.removeClass('hide');
            GP.vent.trigger('Content:add_comment', comment_data);
        }
    },
    // add_reply: function(comment_data) {
    //     //grab content model
    //     comment_data.model = this.model;
    //     GP.vent.trigger('Content:add_comment', comment_data);
    // },
    update_counts: function() {
        this.render();
    },
    throttled_notice_hourly: function() {
        this.ui.alert_throttled.addClass('show');
    },
    throttled_notice_daily: function() {
        this.ui.alert_throttled.addClass('show daily');
    },
    id_throttled_notice: function() {
        this.ui.alert_id_throttled.addClass('show');
    },
    general_error: function() {
        this.ui.alert_general_error.addClass('show').text(this.model.get('general_error'));
    },
    update_comments: function() {
        this.ui.comment_input.val('');
    },
    set_primary_pic: function(e) {
        e.preventDefault();

        var legacy_id = null;
        var $media_container = this.$el.find('.user-media-wrap');

        if (typeof(this.model.get('legacy_type')) !== 'undefined') {
            legacy_id = this.model.get('legacy_id');
        }

        if (confirm(js_lang.profile_text.confirm_pri)) {
            GP.vent.trigger('Content:update_primary');
            this.model.set('media_main_pic', 'Y');
            GP.vent.trigger('profile:set_primary_pic', this.model.get('content_id'), this.model.get('file_md5'), this.model.get('content_media_id'), $media_container, legacy_id);
        }
    },
    delete_content: function(e) {
        e.preventDefault();
        var confirm_del_text = '';

        if (typeof(this.model.get('is_face_pic')) !== 'undefined' && this.model.get('is_face_pic') == 'Y' && (GP.sdata.my_user.verified_pic == 'Y' || GP.sdata.my_user.verified_pic_pending == 'Y')) {
            confirm_del_text = js_lang.content.confirm_del_face_pic;
        } else {
            confirm_del_text = js_lang.content.confirm_del;
        }
        if (confirm(confirm_del_text)) {
            GP.vent.trigger('Content:delete_content', this.model);
        }
    },
    toggle_comment_input: function() {
        if (GP.sdata.my_user.membership == 'FREE') {
            GP.vent.trigger('Page:billing_redirect');
        } else {
            if (MoshPit.get_size() == 'mobile' || MoshPit.get_size() == 'tablet') {
                this.ui.media_comment_input_wrap.toggleClass('shown');
            } else {
                this.ui.comment_input.focus();
            }
        }
    },
    toggle_comment_options: function() {
        this.ui.comment_container.toggleClass('show-comment-options');
    },
    check_comment_char: function() {
        var comment_text = $.trim(this.ui.comment_input.val());

        if (comment_text.length === 0) {
            this.ui.btn_comment.addClass('disabled');
        } else {
            this.ui.btn_comment.removeClass('disabled');
        }

    },
    toggle_comments: function(e) {
        var $wrapper = $(e.currentTarget).parents('.user-media-wrap');

        if (GP.sdata.my_user.membership == 'FREE') {
            GP.vent.trigger('Page:billing_redirect');
        } else {
            GP.vent.trigger('Content:toggle_auto_expand_comments', $wrapper);
        }
    },
    set_private: function() {
        GP.vent.trigger('Content:set_private', this.model);
    },
    set_public: function() {
        GP.vent.trigger('Content:set_public', this.model);
    },
    drop_down_shown: function() {
        // check if dropdown menu's left edge is off the screen and fix
        if (this.ui.dropdown_menu.length) {
            var offset = this.ui.dropdown_menu.offset();
            if (offset) {
                var left_edge = parseInt(offset.left, 10);
                if (_.isFinite(left_edge) && left_edge < 0) {
                    this.ui.dropdown_menu.removeClass('dropdown-menu-right');
                }
            }
        }
    },
    // called when a model is being removed from the collection
    remove: function() {
        var self = this;
        if (this.model.get('fade_out')){
            this.$el.fadeOut(function() {
                Marionette.LayoutView.prototype.remove.call(self);
            });
        } else {
            Marionette.LayoutView.prototype.remove.call(self);
        }
    },
    apply_filter: function() {
        var qs_params = {
            content_id: this.model.get('content_id')
        };

        if (this.model.get('tags').indexOf('PRIVATE') !== -1 || this.model.get('tags').indexOf('PRIVATE_ENFORCED') !== -1) {
            qs_params.private = 1;
        }

        window.location = GP.Util.clean_url('/members/content/filters/', qs_params);
    },
    show_unlock_modal: function() {
        GP.vent.trigger('Unlock:show_unlock_modal', this.model.get('duid'));
    }
});

GP.views.ContentList = Backbone.Marionette.CollectionView.extend({
    childView: GP.views.ContentMediaLayout,
    // emptyView: GP.views.NoResultsItemView
});
